import React from 'react';
import Image from 'next/image';
import Button from '@mui/material/Button';
import CreateResumeBtn from '@/components/resume/resume-marketing/CreateResumeBtn';
import SvgTencent from './SvgTencent';
import SvgAlibaba from './SvgAlibaba';
import SvgWangYi from './SvgWangYi';
import SvgBYD from './SvgBYD';
import SvgXiaoPeng from './SvgXiaoPeng';
import SvgZiJie from './SvgZiJie';
import SvgDiDi from './SvgDiDi';
import { HOME_PAGE_RESUME_EVALUATION_ID } from '@/constants/component-id';
import { useGsapContextSafe } from '@/utils/hooks/useGsapScroll';
import MainBgImage from '@/assets/resume-marketing/main-bg.png';
import { trackClickEvent } from '@/utils/site-track';

const FirstScreen = () => {
  const handleScroll = useGsapContextSafe();

  return (
    <div
      className="p-5 bg-web-blue-100 tablet:pt-19 tablet:px-22.5 tablet:pb-4"
      data-ele-id="content"
      data-ele-group="1st_screen"
      data-observer-id="1st_screen"
    >
      <div className="tablet:max-w-[1200px] tablet:mx-auto">
        <div className="flex justify-between items-center flex-col tablet:flex-row">
          <div className="tablet:max-w-[594px]">
            <p className="text-4xl font-semibold tablet:text-5.5xl">
              <span className="text-transparent bg-clip-text bg-[linear-gradient(91.18deg,#2557a7_0.01%,#409ec8_29.42%,#164081_113.27%)] bg-[length:200%] animate-gradient-move">
                AI智能简历诊断
              </span>
              —让你的简历从普通到卓越
            </p>
            <p className="text-lg mt-4 tablet:text-xl">
              五大职场维度结合智能大模型，精准优化内容结构，让HR一眼看出你的核心竞争力，轻松斩获心动
              offer！
            </p>
            <div className="mt-4 flex gap-9 tablet:mt-16">
              <Button
                className="w-full h-13.5 max-w-[340px] tablet:w-[220px]"
                variant="contained"
                onClick={(e) => {
                  handleScroll({
                    scrollId: HOME_PAGE_RESUME_EVALUATION_ID,
                  });
                  trackClickEvent(e);
                }}
                data-ele-group="1st_screen"
                data-ele-id="btn_简历诊断"
              >
                简历诊断
              </Button>
              <CreateResumeBtn variant="outlined" dataEleGroup="1st_screen" />
            </div>
          </div>
          <div className="w-full mt-4 tablet:mt-0 tablet:max-w-[570px]">
            <Image
              src={MainBgImage}
              alt=""
              style={{
                objectFit: 'contain',
              }}
              priority
            />
          </div>
        </div>
        <div className="flex gap-8 items-center justify-center flex-wrap mt-6 tablet:mt-[95px]">
          <span className="text-sm tablet:text-base">
            谈职帮助人们在世界顶级公司找到工作
          </span>
          <SvgTencent />
          <SvgAlibaba />
          <SvgWangYi />
          <SvgBYD />
          <SvgXiaoPeng />
          <SvgZiJie />
          <SvgDiDi />
        </div>
      </div>
    </div>
  );
};

export default FirstScreen;
